
import { ErrorReason } from '~src/sessionManagement/SessionManagementService';

import { GetBaasClusterDetailsRequest, IGetBaasClusterDetailsParams, IGetBaasClusterDetailsResult } from '../../serverApi/requests/GetBaasClusterDetailsRequest';
import { Cluster } from '../types/Cluster';
import { RequestPoller } from './RequestPoller';



let statusPoller: RequestPoller<IGetBaasClusterDetailsParams, IGetBaasClusterDetailsResult>;

function pollClusterDetailsStats(
  clusters: Record<string, Cluster>,
  siteId: string,
  notifyCallback?: (result: IGetBaasClusterDetailsResult) => void
): Promise<IGetBaasClusterDetailsResult> {
  const request = new GetBaasClusterDetailsRequest({clusterIds: Object.keys(clusters), siteId: siteId});

  const isComplete = (result: IGetBaasClusterDetailsResult): boolean => {
    if (result.success) {
        return false;
    }
    // stop to poll if any error happened
    return true;
  };

  return new Promise((resolve, reject) => {
    statusPoller = new RequestPoller(
      request,
      isComplete,
      (result: IGetBaasClusterDetailsResult) => resolve(result), // success callback
      (reason: ErrorReason) => reject(reason), // failure callback,
      notifyCallback,
    );
    statusPoller.startPolling();
  });
}


function cancelClusterDetailsStatsPolling() {
    statusPoller?.cancelPolling();
  }

  export const ClusterStatusPollService = {
    pollClusterDetailsStats,
    cancelClusterDetailsStatsPolling
  };

  export type ClusterStatusPollService = typeof ClusterStatusPollService;